import styled from 'styled-components';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const PageHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled(Heading)<{ theme: Theme }>`
  padding-bottom: 8px;
  border-bottom: 3px solid ${getColor('borderAccentPrimary')};
  align-self: flex-start;
`;

export const PageInfo = styled(Heading)<{ theme: Theme }>`
  padding-top: 8px;
  align-self: flex-start;
  font-weight: 400;
  line-height: 150%;
  margin-top:-24px; // cancel gap for this element
`;

export const Description = styled.summary<{ theme: Theme }>`
  ${getBodyStyle('graphikCompact', { default: 'default', xlMin: 'large' })};
  text-align: left;
`;
